import { styled } from "@mui/material";
import { chipName } from "../classes.js";
const baseSize = 20;
const ChipBadge = styled("div", {
  name: chipName,
  slot: "ChipBadge",
  overridesResolver: (_props, styles) => [styles.chipBadge]
})(({ theme }) => {
  return {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500,
    letterSpacing: 0.14,
    background: `var(--badge-background-color, ${(theme.vars ?? theme).palette.common.white})`,
    color: `var(--badge-text-color, currentColor)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: `var(--badge-size, ${baseSize}px)`,
    lineHeight: `var(--badge-size, ${baseSize}px)`,
    minWidth: `var(--badge-size, ${baseSize}px)`,
    borderRadius: `calc(var(--badge-size, ${baseSize}px) / 2)`,
    paddingLeft: `var( --badge-padding-x, 6.5px)`,
    paddingRight: `var( --badge-padding-x, 6.5px)`
  };
});
export {
  ChipBadge
};
//# sourceMappingURL=ChipBadge.js.map
